import * as React from 'react';

import * as ReactDOM from 'react-dom';
import { v4 as uuid } from 'uuid';

import { WindowErrors, emburseLoginEnabled, getCompanyIdFromUrl } from '@ReactComponents/Login/loginHelper';

import { LoginPage } from '@ReactComponents/Login/LoginPage';
import { AbacusEmbarkProvider } from '@Shared/AbacusEmbarkProvider';

import '../utils/castle';

interface LoginWrapperWindow extends Window {
  csrf: string;
  errors: WindowErrors;
}

declare const window: LoginWrapperWindow;

function redirectToAccounts() {
  const wc = window.whitelabelConfiguration;
  let href =
    `${wc.account_url}authorize?response_type=id_token` +
    `&client_id=${wc.account_client_id}&redirect_uri=${wc.host}/login/oidc/assertion` +
    `&scope=openid%20email%20licenses&nonce=${uuid()}`;

  const companyId = getCompanyIdFromUrl(window.location?.search);

  if (companyId) {
    href += `&bu_customer_id=${companyId}`;
  }

  window.location.href = href;
}

// reset sidebar expanded menu states
sessionStorage.removeItem('expandedMenuIds');

if (window.FEATURES?.emburse_login && emburseLoginEnabled(window.location?.search)) {
  redirectToAccounts();
}

// Set the public path for webpacked assets
// https://webpack.js.org/guides/public-path/
__webpack_public_path__ = window.webpack_public_path;
ReactDOM.render(
  <AbacusEmbarkProvider>
    <LoginPage csrf={window.csrf} locals={window.errors} />
  </AbacusEmbarkProvider>,
  document.querySelector('#app')
);
